import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center p-4 bg-gray-800 text-white h-full" }
const _hoisted_2 = { class: "flex flex-col items-center pb-6 gap-2" }
const _hoisted_3 = { class: "text-lg font-semibold" }
const _hoisted_4 = { class: "flex flex-col w-full" }

import { PropType } from "vue";
import { useUsersStore } from "@/stores/v2";
import AuthService from "@/services/v2/auth";


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarMain',
  props: {
  showModal: {
    type: Boolean,
    default: false,
  },
  toggleAbortModal: {
    type: Function as PropType<(payload: MouseEvent) => void>,
    required: true,
  },
},
  setup(__props) {

const userStore = useUsersStore();


const handleLogout = () => {
    // Clean store
    userStore.logout();
    // Close session
    AuthService.logout();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex items-center justify-center rounded-full bg-white p-5" }, [
        _createElementVNode("svg", {
          width: "22px",
          height: "22px",
          viewBox: "0 0 12 12",
          "enable-background": "new 0 0 12 12",
          id: "layer_1",
          version: "1.1",
          "xml:space": "preserve",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink"
        }, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              d: "M9.3005371,6.5351563C8.4776001,7.4294434,7.3084106,8,6,8S3.5223999,7.4294434,2.6994629,6.5351563   C1.3145142,7.2350464,0.5,8.6131592,0.5,10.5V12h11v-1.5C11.5,8.6131592,10.6854858,7.2350464,9.3005371,6.5351563z",
              fill: "#e3e3e3"
            }),
            _createElementVNode("circle", {
              cx: "6",
              cy: "3.5",
              fill: "#e3e3e3",
              r: "3.5"
            })
          ])
        ])
      ], -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(userStore).getCurrentUser?.name), 1)
    ]),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.toggleAbortModal && __props.toggleAbortModal(...args))),
        class: "py-2 cursor-pointer text-primary bg-white px-4 rounded-md transition-colors"
      }, " Dashboard ")
    ]),
    _createElementVNode("div", { class: "flex flex-col w-full mt-auto" }, [
      _cache[2] || (_cache[2] = _createElementVNode("button", { class: "py-2 px-4 bg-red-600 hover:bg-red-700 rounded-md transition-colors mb-2" }, " Report an Error ", -1)),
      _createElementVNode("button", {
        onClick: handleLogout,
        class: "py-2 px-4 bg-blue-600 hover:bg-blue-700 rounded-md transition-colors"
      }, " Logout ")
    ])
  ]))
}
}

})